import { documentHasElements } from "modules/dom";
import "./global-career-front-page.scss";

documentHasElements(".js-global-career-frontpage", () => {

    const careerFrontPage = {
        init: function () {
            careerFrontPage.addSmoothScroll();
        },
        addSmoothScroll: () => {
            const html = document.querySelector("html");
            
            if (html) {
                html.classList.add("html-scroll__smooth");
            }
        },
    };

    careerFrontPage.init();

});